/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';
import { makeShirtQuestions } from './shirt-questions';

export const PRCR_WAREHOUSE_CATEGORIES: SupportCategory[] = [
  { id: 'prcr-supply-bins', label: 'Supply Bins', departmentId: 'PRCR Warehouse' },
  { id: 'prcr-merchandise', label: 'Merchandise', departmentId: 'PRCR Warehouse' },
  { id: 'prcr-lookbook', label: 'Lookbook/Event Bin', departmentId: 'PRCR Warehouse' },
  { id: 'prcr-storage', label: 'Storage', departmentId: 'PRCR Warehouse' },
];

export const PRCR_SHIRTS_POLOS_SUBCATEGORY_ID = 'prcr-merchandise-shirts-polos';

export const PRCR_WAREHOUSE_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'prcr-supply-feedback', label: 'Feedback', categoryId: 'prcr-supply-bins' },
  { id: 'prcr-supply-request', label: 'Request', categoryId: 'prcr-supply-bins' },
  { id: 'prcr-supply-classroom', label: 'Classroom Open/ Closure', categoryId: 'prcr-supply-bins' },
  { id: PRCR_SHIRTS_POLOS_SUBCATEGORY_ID, label: 'Shirts/Polos', categoryId: 'prcr-merchandise' },
  { id: 'prcr-merchandise-welcome-bags', label: 'Staff Welcome Bags', categoryId: 'prcr-merchandise' },
  { id: 'prcr-merchandise-incentives', label: 'Staff Incentives', categoryId: 'prcr-merchandise' },
  { id: 'prcr-lookbook', label: 'Lookbook/Event Bin', categoryId: 'prcr-lookbook' },
  { id: 'prcr-storage', label: 'Storage', categoryId: 'prcr-storage' },
];

export const PRCR_WAREHOUSE_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'prcr-feedback-1',
    subcategoryId: 'prcr-supply-feedback',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-feedback-2',
    subcategoryId: 'prcr-supply-feedback',
    type: 'text',
    label: 'Age Group',
    required: true,
  },
  {
    id: 'prcr-feedback-3',
    subcategoryId: 'prcr-supply-feedback',
    type: 'text',
    label: 'Classroom Number',
    required: true,
  },
  {
    id: 'prcr-feedback-4',
    subcategoryId: 'prcr-supply-feedback',
    type: 'text',
    label: 'Monthly Theme and Week',
    required: true,
  },
  {
    id: 'prcr-feedback-5',
    subcategoryId: 'prcr-supply-feedback',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-feedback-6',
    subcategoryId: 'prcr-supply-feedback',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  {
    id: 'prcr-request-1',
    subcategoryId: 'prcr-supply-request',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-request-2',
    subcategoryId: 'prcr-supply-request',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-request-3',
    subcategoryId: 'prcr-supply-request',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'prcr-request-4',
    subcategoryId: 'prcr-supply-request',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  {
    id: 'prcr-classroom-1',
    subcategoryId: 'prcr-supply-classroom',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-classroom-2',
    subcategoryId: 'prcr-supply-classroom',
    type: 'select',
    label: 'Open/ Close',
    required: true,
    options: [
      { value: 'Open', label: 'Open' },
      { value: 'Close', label: 'Close' },
    ],
  },
  {
    id: 'prcr-classroom-3',
    subcategoryId: 'prcr-supply-classroom',
    type: 'text',
    label: 'Age Group',
    required: true,
  },
  {
    id: 'prcr-classroom-4',
    subcategoryId: 'prcr-supply-classroom',
    type: 'text',
    label: 'Classroom Number',
    required: true,
  },
  {
    id: 'prcr-classroom-5',
    subcategoryId: 'prcr-supply-classroom',
    type: 'date',
    label: 'Date It will open/ close',
    required: true,
  },
  {
    id: 'prcr-classroom-6',
    subcategoryId: 'prcr-supply-classroom',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-classroom-7',
    subcategoryId: 'prcr-supply-classroom',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  {
    id: 'prcr-welcome-1',
    subcategoryId: 'prcr-merchandise-welcome-bags',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-welcome-2',
    subcategoryId: 'prcr-merchandise-welcome-bags',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-welcome-3',
    subcategoryId: 'prcr-merchandise-welcome-bags',
    type: 'text',
    label: 'How Many Bags Do You need',
    required: true,
  },
  {
    id: 'prcr-welcome-4',
    subcategoryId: 'prcr-merchandise-welcome-bags',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'prcr-welcome-5',
    subcategoryId: 'prcr-merchandise-welcome-bags',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'prcr-incentives-1',
    subcategoryId: 'prcr-merchandise-incentives',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-incentives-2',
    subcategoryId: 'prcr-merchandise-incentives',
    type: 'text',
    label: 'What type of merchandise do you need?',
    required: true,
  },
  {
    id: 'prcr-incentives-3',
    subcategoryId: 'prcr-merchandise-incentives',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-incentives-4',
    subcategoryId: 'prcr-merchandise-incentives',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'prcr-incentives-5',
    subcategoryId: 'prcr-merchandise-incentives',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'prcr-lookbook-1',
    subcategoryId: 'prcr-lookbook',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-lookbook-2',
    subcategoryId: 'prcr-lookbook',
    type: 'text',
    label: 'Month of bin',
    required: true,
  },
  {
    id: 'prcr-lookbook-3',
    subcategoryId: 'prcr-lookbook',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-lookbook-4',
    subcategoryId: 'prcr-lookbook',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'prcr-storage-1',
    subcategoryId: 'prcr-storage',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'prcr-storage-2',
    subcategoryId: 'prcr-storage',
    type: 'text',
    label: 'Do you need something delivered or picked up?',
    required: true,
  },
  {
    id: 'prcr-storage-3',
    subcategoryId: 'prcr-storage',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'prcr-storage-4',
    subcategoryId: 'prcr-storage',
    type: 'date',
    label: 'When do you need this completed by:',
    required: true,
  },
  {
    id: 'prcr-storage-5',
    subcategoryId: 'prcr-storage',
    type: 'file',
    label: 'Attach photo option',
    required: false,
  },
  ...makeShirtQuestions('prcr', PRCR_SHIRTS_POLOS_SUBCATEGORY_ID),
];
